module.exports = __webpack_public_path__ + "static/touchSupport-f383cc93819822b679ead1539b99c6a3.gif";